import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, ViewChild} from '@angular/core';
import {SmsirButtonHttpLoadingDirective} from '@shared/directives/smsir-button-http-loading.directive';

import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

import {TextBuilderTypeEnum} from '../../../../text-builder/models/text-builder-type.enum';
import {SharedService} from '@shared/services/shared.service';
import {TextBuilderComponent} from '@app/main/modules/text-builder/text-builder.component';

export interface ModifyTextMessageModalData {
  defaultText: string;
}

@Component({
  selector: 'app-modify-text-message-modal',
  standalone: true,
  imports: [ButtonComponent, TextBuilderComponent,
    SmsirButtonHttpLoadingDirective,
  ],
  templateUrl: './modify-text-message-modal.component.html',
  styleUrls: ['./modify-text-message-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifyTextMessageModalComponent implements OnInit {
  @ViewChild(TextBuilderComponent) private textBuilder?: TextBuilderComponent;

  private readonly modalRef = inject<ModalRef<string | false>>(ModalRef);
  private readonly data = inject<ModifyTextMessageModalData>(MODAL_DATA);
  readonly shareService = inject(SharedService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  readonly textBuilderTypeEnum = TextBuilderTypeEnum;
  readonly defaultText = this.data.defaultText;
  text = '';
  maxLengthValid = false;

  ngOnInit(): void {
    this.text = this.defaultText;
  }

  validateMaxLength($event: boolean): void {
    this.maxLengthValid = $event;
  }

  messageTextChanged($event: string): void {
    this.text = $event;
  }

  onSubmit(): void {
    if (!this.textBuilder?.validateAndScroll()) {
      this.changeDetectorRef.markForCheck();
      return;
    }
    if (!this.maxLengthValid) {
      this.changeDetectorRef.markForCheck();
      return;
    }
    if (this.text === this.defaultText) {
      this.changeDetectorRef.markForCheck();
      return;
    }

    this.modalRef.close(this.text);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
